export const STYLE_FIELD_NAME = "style";
export const STYLE_CAPABILITIES_FIELD_NAME = "styleCapabilities";
export const STYLE_COMPONENTS_FIELD_NAME = "styleComponents";
